
import { css } from 'lit';
export default css`
.cta-location-hero__wrapper {
  position: relative;
}
  .cta-location-hero__wrapper {
  display: flex;
}
  .cta-location-hero__wrapper {
  flex-direction: row;
}
  .cta-location-hero__image {
  display: none;
}
  @media (min-width: 768px) {
  .cta-location-hero__image {
    position: relative;
  }
}
  @media (min-width: 768px) {
  .cta-location-hero__image {
    display: flex;
  }
}
  @media (min-width: 768px) {
  .cta-location-hero__image {
      width: 55%
  }
    }
  .cta-location-hero__image slot, .cta-location-hero__image div[slot="image"] {
      width: 100%;
    }
  @media (min-width: 768px) {
  .cta-location-hero__map {
      width: 100%;
      margin-right: calc(50% - 50vw)
  }
    }
  @media (min-width: 1024px) {
  .cta-location-hero__map {
      margin-left: 100px
  }
    }
  .cta-location-hero__image--mobile {
  margin-bottom: 2rem;
}
  .cta-location-hero__image--mobile {
  width: 100%;
}
  .cta-location-hero__content {
  margin-top: 0.5rem;
}
  .cta-location-hero__content {
  display: flex;
}
  .cta-location-hero__content {
  width: 100%;
}
  .cta-location-hero__content {
  flex-shrink: 0;
}
  .cta-location-hero__content {
  flex-direction: column;
}
  .cta-location-hero__content {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
}
  @media (min-width: 768px) {
  .cta-location-hero__content {
    padding-right: 3rem;
  }
}
  @media (min-width: 1200px) {
  .cta-location-hero__content {
    width: auto;
  }
}
  @media (min-width: 768px) {
  .cta-location-hero__content {
      width: 45%
  }
    }
  .cta-location-hero__title {
  margin-bottom: 1.5rem;
}
  @media (min-width: 768px) {
  .cta-location-hero__title {
    margin-bottom: 0.75rem;
  }
}
  .cta-location-hero__text {
  margin-bottom: 1.5rem;
}
  .cta-location-hero__text {
  font-size: 1.125rem;
}
  .cta-location-hero__link {
  padding-bottom: 1.25rem;
}
  .cta-location-hero__link {
  font-size: 1.125rem;
}
  .cta-location-hero__link {
  font-weight: 700;
}
  .cta-location-hero__link {
  --tw-text-opacity: 1;
  color: rgba(107, 31, 153, var(--tw-text-opacity));
}
  .cta-location-hero__link:hover {
  --tw-text-opacity: 1;
  color: rgba(53, 25, 108, var(--tw-text-opacity));
}
  .cta-location-hero__link:hover {
  text-decoration: underline;
}
  @media (min-width: 768px) {
  .cta-location-hero__link {
    font-size: 1.25rem;
  }
}
  .cta-location-hero__icon {
  margin-right: 0.75rem;
}
  .cta-location-hero__icon {
  margin-top: 2px;
}
  .cta-location-hero__icon {
  height: 1.5rem;
}
  .cta-location-hero__icon {
  width: 1.5rem;
}
  .cta-location-hero__button {
  margin-top: 1.25rem;
}
  @media (min-width: 768px) {
  .cta-location-hero__button {
      width: -webkit-fit-content;
      width: -moz-fit-content;
      width: fit-content
  }
    }
`;